import { SidebarItem } from './sidebaritem';

export class MenuItemEvent {
	constructor(
		public htmlElement: HTMLElement,
		public item: SidebarItem,
	) {}
}
